/**
 * Valida se um campo corresponde à outro
 */
export const matchField =
  (field: string, message: string) =>
  (value: string, allValues: { [x: string]: string }): string | undefined => {
    return value !== allValues[field] ? message : undefined
  }
